import { Injectable, signal } from '@angular/core';

export enum SnackbarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export enum SnackbarClass {
  SUCCESS = 'success-snackbar',
  ERROR = 'error-snackbar',
  WARNING = 'warning-snackbar',
  INFO = 'info-snackbar',
}

export interface SnackbarMessage {
  id: string;
  message: string;
  type: SnackbarType;
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private readonly messages = signal<SnackbarMessage[]>([]);
  readonly messagesSignal = this.messages.asReadonly();

  private idCounter = 0;

  showToaster(type: SnackbarType, message: string, duration = 5000): void {
    const id = `snackbar-${++this.idCounter}`;
    this.messages.update((current) => [...current, { id, message, type }]);
    setTimeout(() => this.remove(id), duration);
  }

  remove(id: string): void {
    this.messages.update((current) => current.filter((msg) => msg.id !== id));
  }
}
